import { useTranslations } from "next-intl";
import { useSubscriptionStatus } from "@hooks/use-current-user";

function SubscriptionRecapNextStatus() {
  const t = useTranslations("accounts");

  const subscriptionStatus = useSubscriptionStatus();

  return (
    <p
      className="mb-0 text-gray"
      data-testid="manage-subscription-recap-status-section"
    >
      {t.rich(`manage_subscription.status.${subscriptionStatus}`, {
        span: (chunks) => <span className="text-dark">{chunks}</span>,
      })}
    </p>
  );
}

export default SubscriptionRecapNextStatus;
